import { useSuspenseQuery } from '@tanstack/react-query';
import { regionGet } from '@/api/core/region/regionGet';

export const useRegion = () => useSuspenseQuery({
    queryKey: ['region'],
    queryFn: () => regionGet().then(r => r.payload).catch(() => ({ atc_active: 0, traffic: 0 }))
});
